import Swal from "sweetalert2";

export interface AuthDialogOptions {
  /** Called when user chooses "Continue as Guest" (confirm button) */
  onContinueAsGuest?: () => void;
  onUserRegistration: () => void;
  onAlreadyHaveAccount: () => void;
}

/**
 * Show verification dialog with 3 options
 * Confirm: Continue as Guest
 * Deny: User Registration
 * Link: Already have Account?
 */
export const showAuthVerificationDialog = (options: AuthDialogOptions) => {
  Swal.fire({
    icon: "warning",
    title: "User Not Verified",
    html: `
      <div style="font-size: 14px; text-align: center; margin-bottom: 1.5rem;">
        <p style="margin: 0; color: #555;">Please select an option to continue:</p>
      </div>
      <div style="margin-top: 2rem;">
        <p style="font-size: 13px; color: #999; margin: 1rem 0;">
          Already have an account? 
          <a href="#" id="alreadyHaveAccount" style="color: #dc3545; text-decoration: none; font-weight: 600; cursor: pointer;">
            Login Here
          </a>
        </p>
      </div>
    `,
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: "Continue as Guest",
    denyButtonText: "Create New Account",
    confirmButtonColor: "#dc3545",
    denyButtonColor: "var(--gold-500)",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: (modal) => {
      // Add click handler for the link
      const link = modal.querySelector("#alreadyHaveAccount");
      if (link) {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          Swal.close();
          options.onAlreadyHaveAccount();
        });
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      if (options.onContinueAsGuest) {
        try {
          // allow async handlers but don't await here
          options.onContinueAsGuest();
        } catch (err) {
          // swallow handler errors to avoid unhandled rejections here
          // callers should handle/report their own errors
          // eslint-disable-next-line no-console
          console.error("onContinueAsGuest handler error", err);
        }
      }
    } else if (result.isDenied) {
      options.onUserRegistration();
    }
  });
};
